import React, { Component } from "react";
import styles from "./FloatComponents.module.scss";
import Search from "../Search/Search";
import CategoryCarousel from "components/Filter/CategoryCarousel/CategoryCarousel";
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet';
import MenuBottom from "components/MenuBottom/MenuBottom";

export default class FloatComponents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }

    openModal() {
        this.setState({
            visible: true
        });
    }

    closeModal() {
        this.setState({
            visible: false
        });
    }

    render() {
        return (
            <div className={styles.floatComponents}>
                <div className={styles.top}>
                    <div className={styles.search}>
                        <Search 
                            filtrar={this.props.filtrar}
                            selectedMkr={this.props.selectedMkr}
                            setSelectedMkr={this.props.setSelectedMkr}
                            categorias={this.props.categorias}
                            setZoom={this.props.setZoom}
                            setIsSeenOnMap={this.props.setIsSeenOnMap}
                            setFilterText={this.props.setFilterText}
                            filterText={this.props.filterText}
                        />
                        <MenuBottom 
                            estabelecimentosFavoritos={
                                this.props.estabelecimentosFavoritos
                            }
                            selectedMkr={this.props.selectedMkr}
                            estabelecimentos={this.props.estabelecimentos}
                            userLocation={this.props.userLocation}
                            setSelectedEstabelecimento={
                                this.props.setSelectedEstabelecimento
                            }
                            favoritar={this.props.favoritar}
                        /> 
                    </div>
                </div>

                <div className={styles.menuResponsive}>
                    <SwipeableBottomSheet overflowHeight={64} marginTop={8} >
                        <div className={styles.menuBottomResponsive}>
                            <CategoryCarousel 
                                filtrar={this.props.filtrar}
                                selectedMkr={this.props.selectedMkr}  
                                setSelectedMkr={this.props.setSelectedMkr}
                                categorias={this.props.categorias}
                                setIsSeenOnMap={this.props.setIsSeenOnMap}
                                setZoom={this.props.setZoom}
                                setFilterText={this.props.setFilterText}
                                filterText={this.props.filterText}
                                isSeenOnMap={this.props.isSeenOnMap}
                            />
                        </div>
                    </SwipeableBottomSheet>
                </div>
            </div>
        );
    }
}